/**
 * Returns detailed GraphQL errors from an error object
 *
 * @param {Object} error
 *
 * @returns {Array<string>}
 */
export default function getGraphqlDetailedErrors(error) {
  return (
    error?.graphQLErrors?.flatMap((graphQLError) => {
      const extensionErrors = graphQLError?.extensions?.errors;

      if (Array.isArray(extensionErrors) && extensionErrors.length > 0) {
        return extensionErrors;
      }

      return graphQLError?.message ? [graphQLError.message] : [];
    }) ?? []
  );
}
